var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ad)?_c('div',{staticClass:"advertisement-placement",style:(_vm.containerStyle)},[_c('a',{attrs:{"href":_vm.ad.url},on:{"click":function($event){$event.preventDefault();return _vm.openLink(_vm.ad.url)}}},[_c('img',{style:(_vm.imageStyle),attrs:{"src":_vm.imageURL(_vm.ad.image),"alt":_vm.ad.name}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }